import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Colors } from 'chart.js';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-kalaignar100',
  templateUrl: './kalaignar100.component.html',
  styleUrls: ['./kalaignar100.component.scss'],
})
export class Kalaignar100Component implements OnInit {
  winners: any[] = [];
  selectedImages: File[] = [];
  serialNumber: number = 1;
  winnerform: FormGroup;
  dtOptions: DataTables.Settings = {};
  hidden: boolean = true;
  district: string;
  constituency: string = '';
  message: boolean;
  spinner: boolean;
  districtname: any;
  tableshow: boolean;
  isButtonDisabled: boolean = false;
  loginuser: any;
  catagory: any = this.ApiService.catagory;
  imageField: boolean = false;
  // photo1File: File;
  submitted = false;
  //formData = new FormData();
  constructor(
    public ApiService: ApiServiceService,
    private fb: FormBuilder,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.district = JSON.parse(localStorage.getItem('user_district'));
  }
  district_list: any[] = this.ApiService.all_districts;
  constituency_list: any = this.ApiService.all_constituency;
  user_constituency: any;
  winnerImages: string[] = [];
  isButtonVisible: boolean = true;
  ngOnInit(): void {
    // this.addRow();

    // this.districtname = this.Constituency_selection(this.user_constituency);
    let obj = this.constituency_list;
    this.user_constituency = obj[this.district];
    this.showSpinner();
    console.log(this.districtname);
    this.loginuser = JSON.parse(localStorage.getItem('login_user_details'));
    

    console.log(this.loginuser.id);
    this.spinner = true;
    this.dtOptions[0] = {
      pagingType: 'full_numbers',
      order: [],
    };
    this.FormInitialize();
    // this.addRow();
  }
  FormInitialize() {
    this.winnerform = this.fb.group({
      no_of_participants: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[0-9]+$/),
      ]),
      venue: new FormControl('', [Validators.required]),
      date_of_compertition: new FormControl('', [Validators.required]),
      // photo1: new FormControl('', [Validators.required]),
      images1: [''],
      images2: [''],
      images3: [''],
      images4: [''],
      images5: [''],
      winners: this.fb.array([this.createWinnerFormGroup(0)]),
    });

  }
  addRow() {
    const wincontrol = this.winnersArray();
    console.log(wincontrol.length)
    if (wincontrol.length < 15) {
    wincontrol.push(this.createWinnerFormGroup(wincontrol.length));
    // wincontrol
    //   .at(wincontrol.length - 1)
    //   .get('images')
    //   .setValue(null);
    // }
    }
  }

  createWinnerFormGroup(i: number) {
    return this.fb.group({
      position: new FormControl('', [Validators.required]),
      register_number: new FormControl('', [Validators.required]),
      student_name: new FormControl('', [Validators.required]),
      college_name: new FormControl('', [Validators.required]),
      mobile_number: new FormControl('', [
        Validators.required,
        Validators.pattern('[6789][0-9]{9}'),
      ]),
      topic: new FormControl('', [Validators.required]),
      photo: [''],
    });
  }
  removeRow(index: number) {
    const winnersArray = this.winnerform.get('winners') as FormArray;
    winnersArray.removeAt(index);
  }

  public showSpinner(): void {
    this.spinnerService.show();
  }

  Constituency_selection(selection: any) {
    console.log(selection)
    // this.districtname= selection;
    this.ApiService.district_check_winner(selection).subscribe(
      (data) => {
        console.log(data)
        // console.log(this.districtname);
        if (data === selection) {
          this.isButtonVisible = true;
          // console.log('Your district Winner list are already updated');
          alert('Your Constituency '+  selection +' Winner list are already updated');
                    this.router.navigate(['districtadmin/Winner_List_show']);
        } else {
          this.isButtonVisible = false;
        }
        // this.spinnerService.hide();
        // this.isButtonVisible = true;
        // alert("Your district Winner list is already updated");
      },
      (error) => {
        console.log(error);
      }
    );

    // if (selection != 'null') {
    //   console.log(this.district);
    //   let obj = this.constituency_list;
    //   this.user_constituency = obj[this.district];
    // }
  }

  reload() {
    window.location.reload();
  }
  nopost_Error_msg: boolean = false;
  nopost_msg() {
    this.nopost_Error_msg = true;
  }
  fileFormatStatuss: any=[];

  fileSizeStatuss: any=[];

  imageSrc: string;
  imageSrc1: string;
  imageSrc2: string;
  imageSrc3: string;
  imageSrc4: string;
  imageSrc5: string;
  userImage: any;
  fileFormatStatus1: boolean = false;
  fileFormatStatus2: boolean = false;
  fileFormatStatus3: boolean = false;
  fileFormatStatus4: boolean = false;
  fileFormatStatus5: boolean = false;

  fileSizeStatus1: boolean = false;
  fileSizeStatus2: boolean = false;
  fileSizeStatus3: boolean = false;
  fileSizeStatus4: boolean = false;
  fileSizeStatus5: boolean = false;

  // fileSizeStatus:boolean=false;
  // Get image from user input
  onFileChange(event, formtype) {

    let ImagesAllowed: Array<string> = ['image/png', 'image/jpg', 'image/jpeg'];

    const reader = new FileReader();
    if (event.target.files.length > 0) {
      const [file] = event.target.files;
      console.log(file);
      //checks if the format is allowed
      if (ImagesAllowed.includes(file.type) == false) {
        if (formtype == 'images1') {
          this.fileFormatStatus1 = true;
          this.imageSrc1 = null;
          this.userImage = null;
        }
        if (formtype == 'images2') {
          this.fileFormatStatus2 = true;
          this.imageSrc2 = null;
          this.userImage = null;
        }
        if (formtype == 'images3') {
          this.fileFormatStatus3 = true;
          this.imageSrc3 = null;
          this.userImage = null;
        }
        if (formtype == 'images4') {
          this.fileFormatStatus4 = true;
          this.imageSrc4 = null;
          this.userImage = null;
        }
        if (formtype == 'images5') {
          this.fileFormatStatus5 = true;
          this.imageSrc5 = null;
          this.userImage = null;
        }
      } else if (file.size > 1000000) {
        if (formtype == 'images1') {
          this.fileSizeStatus1 = true;
          this.imageSrc1 = null;
          this.userImage = null;
        }
        if (formtype == 'images2') {
          this.fileSizeStatus2 = true;
          this.imageSrc2 = null;
          this.userImage = null;
        }
        if (formtype == 'images3') {
          this.fileSizeStatus3 = true;
          this.imageSrc3 = null;
          this.userImage = null;
        }
        if (formtype == 'images4') {
          this.fileSizeStatus4 = true;
          this.imageSrc4 = null;
          this.userImage = null;
        }
        if (formtype == 'images5') {
          this.fileSizeStatus5 = true;
          this.imageSrc5 = null;
          this.userImage = null;
        }
      } else {
        reader.readAsDataURL(file);
        reader.onload = () => {
          // this.imageSrc = reader.result as string;
          const file = (event.target as HTMLInputElement).files[0];
          if (formtype == 'images1') {
            this.fileFormatStatus1 = false;
            this.fileSizeStatus1 = false;
            this.imageSrc1 = reader.result as string;
            // this.userImage=reader.result as string;
            this.winnerform.patchValue({
              images1: file,
            });
          }
          if (formtype == 'images2') {
            this.fileFormatStatus2 = false;
            this.fileSizeStatus2 = false;
            this.imageSrc2 = reader.result as string;
            // this.userImage=reader.result as string;
            this.winnerform.patchValue({
              images2: file,
            });
          }
          if (formtype == 'images3') {
            this.fileFormatStatus3 = false;
            this.fileSizeStatus3 = false;
            this.imageSrc3 = reader.result as string;
            // this.userImage=reader.result as string;
            this.winnerform.patchValue({
              images3: file,
            });
          }
          if (formtype == 'images4') {
            this.fileFormatStatus4 = false;
            this.fileSizeStatus4 = false;
            this.imageSrc4 = reader.result as string;
            this.winnerform.patchValue({
              images4: file,
            });
          }
          if (formtype == 'images5') {
            this.fileFormatStatus5 = false;
            this.fileSizeStatus5 = false;
            this.imageSrc5 = reader.result as string;
            // this.userImage=reader.result as string;
            this.winnerform.patchValue({
              images5: file,
            });
          }
        };
      }
    }
    if (formtype == 'images1') {
      this.winnerform.get('images1').updateValueAndValidity();
    }
    if (formtype == 'images2') {
      this.winnerform.get('images2').updateValueAndValidity();
    }
    if (formtype == 'images3') {
      this.winnerform.get('images3').updateValueAndValidity();
    }
    if (formtype == 'images4') {
      this.winnerform.get('images4').updateValueAndValidity();
    }
    if (formtype == 'images5') {
      this.winnerform.get('images5').updateValueAndValidity();
    }
  }

  onImageArray(event, formtype, index) {
     this.fileFormatStatuss[index]= 1;
    this.fileSizeStatuss[index] = 1;
    let ImagesAllowed: Array<string> = ['image/png', 'image/jpg', 'image/jpeg'];

    const reader = new FileReader();
    if (event.target.files.length > 0) {
      const [file] = event.target.files;
      // console.log(file);
      console.log(1)
      // Checks if the format is allowed
      if (!ImagesAllowed.includes(file.type)) {
        console.log(2)
        this.fileFormatStatuss[index] = 0;
        this.imageSrc = null;
        this.userImage[index] = null;
      } else if (file.size > 1000000) {
        console.log(3)
        this.fileSizeStatuss[index] = 0;
        this.imageSrc = null;
        this.userImage = null;
      } else {
        console.log(1)
        this.fileFormatStatuss[index] = 11;
        this.fileSizeStatuss[index] = 11;
        reader.readAsDataURL(file);
        reader.onload = () => {
          const newFileControl = new FormControl(file);

          // Get the FormArray for 'winners'
          const winnersArray = this.winnerform.get('winners') as FormArray;

          // Get the FormGroup at the specified index
          const winnerFormGroup = winnersArray.at(index) as FormGroup;

          // Add the new FormControl to the FormGroup
          winnerFormGroup.addControl('photo1', newFileControl);

          // Optionally, you can update the winnerImages array if needed
          this.winnerImages[index] = reader.result as string;

          // Log the value of the newly created FormControl
          winnerFormGroup.get('photo1').setValue(file);
          console.log(winnerFormGroup.get('photo1').value);
        };
      }
    }
  }

  postdata() {
    console.log(this.winnerform.value);
    console.log(this.loginuser.id);
    this.submitted = false;
    if (this.winnerform.valid) {
      const formValues = this.winnerform.value;
      formValues.user_id = this.loginuser.id;
      // Append district and constituency to the form values
      formValues.district = this.district;
      formValues.constituency = this.constituency;
      console.log(formValues);

      const formData = new FormData();

      const winnersWithPhoto1 = formValues.winners.map((winner) => {
        const winnerClone = { ...winner };
        if (winnerClone.photo1) {
          const photo1Blob = new Blob([winnerClone.photo1], {
            type: winnerClone.photo1.type,
          });
          winnerClone.photo1 = photo1Blob;
        }
        return winnerClone;
      });

      // Include the updated winners array in your formValues
      formValues.winners = winnersWithPhoto1;

      // Now stringify the updated formValues
      const updatedWinnersData = JSON.stringify(formValues.winners);

      console.log(updatedWinnersData);

      // Append the JSON string to FormData
      formData.append('winners_form', updatedWinnersData);

      // Iterate through the properties of formValues and append them to formData
      for (const key in formValues) {
        if (formValues.hasOwnProperty(key)) {
          if (key === 'winners') {
            // Handle the 'winners' array by appending each winner's data
            const winnersArray = formValues[key];
            for (let i = 0; i < winnersArray.length; i++) {
              const winner = winnersArray[i];
              for (const winnerKey in winner) {
                if (winner.hasOwnProperty(winnerKey)) {
                  if (winnerKey === 'photo1') {
                    // Append the Blob object as a file with a unique name
                    formData.append(
                      `${key}[${i}][${winnerKey}]`,
                      winner[winnerKey],
                      `${i}_photo1.jpg`
                    );
                  } else {
                    formData.append(
                      `${key}[${i}][${winnerKey}]`,
                      winner[winnerKey]
                    );
                  }
                }
              }
            }
          } else {
            // Append other form values to FormData
            formData.append(key, formValues[key]);
          }
        }
      }
      this.ApiService.winner_list(formData)
        .pipe()
        .subscribe(
          (data) => {
            // alert(data);
            setTimeout(function () {
              alert('Winners are added sucessfully ');
              window.location.reload();
            }, 100);

            //this.router.navigate(['superadmin/Meetings']);
            //angForm1.reset();
          },

          (error) => {
            console.log(error);
          }
        );
    } else {
      this.hidden = false;
    }
  }

  // Getter for accessing the winners FormArray
  winnersArray() {
    return this.winnerform.get('winners') as FormArray;
  }
}